import { useEffect, useState } from "react";
import { ICarModel } from "../interfaces";

const useFetchCarModels = (currentTime: number, selectedCarBrand: string) => {
  const [carModelList, setCarModelList] = useState<ICarModel[]>([]);

  useEffect(() => {
    const fetchCarModels = async () => {
      try {
        if (selectedCarBrand) {
          const response = await fetch(
            `/api/get_car_model_list?brand_id=${selectedCarBrand}&current_time=${currentTime}`
          );
          const data = await response.json();

          const modelEntries = Object.entries(data);
          const models: ICarModel[] = modelEntries.map(([id, name]) => ({
            id,
            name: name as string,
          }));

          setCarModelList(models);
        }
      } catch (error) {
        console.error("Error fetching car models:", error);
      }
    };

    fetchCarModels();
  }, [currentTime, selectedCarBrand]);

  return carModelList;
};

export default useFetchCarModels;
